module.exports = __webpack_public_path__ + "img/radiaIcon1.bab98ed6.svg";